<!--空状态-->
<template>
  <div v-if="isEmpty && !loading" class="sidebar-empty">
    <el-empty :description="emptyText" />
  </div>
</template>
<script setup lang="ts">
defineProps({
  emptyText: {
    type: String,
    default: '暂无数据'
  },
  isEmpty: {
    type: Boolean,
    default: true
  },
  loading: {
    type: Boolean,
    default: false
  }
})
</script>
